import Call from './Call';
import Gallery from './Gallery';
import HandShake from './HandShake';
import Information from './Information';
import Loupe from './Loupe';


const Svg = {
  Call,
  Gallery,
  HandShake,
  Information,
  Loupe,
};

export default Svg;
